import React, { useState, useMemo, useEffect } from "react";
import { MoveLeft, ChevronDown, EllipsisVertical, ChevronLeft, ChevronRight } from "lucide-react";
import service from "../../../assets/svg/service.svg";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, ToastContainer, Toast } from "react-bootstrap";
import tata from "../../../assets/Vehicles/tata.png";
import pdf from "../../../assets/svg/pdf.svg";
import vendor from "../../../assets/svg/vendor.svg";
import calender from "../../../assets/svg/calender.svg";
import user from "../../../assets/Dashboard/user.png";
import labor from "../../../assets/svg/Labor.svg";
import parts from "../../../assets/svg/parts.svg";
import total from "../../../assets/svg/total.svg";
import down from "../../../assets/Vehicles/chevron_down.png";

import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import { Columns } from "../../Vehicles/Column";
import MOCK_DATA from "../../Vehicles/MOCK_DATA.json";
import attachment from "../../../assets/png/attachment.png";
import "../../../Util.css";
import { getServiceDetailsApi } from "../services-api.js";
import download from "../../../assets/svg/download.svg";
import StatusUpdateModal from "./status-update.js";
import { useGlobal } from "../../../GlobalContext.js";

export const ViewService = () => {
   const { rolePermissionList, userType } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== undefined && id !== 0) {
      getServiceDetails();
    }
  }, [id]);

  const [serviceDetail, setServiceDetail] = useState({});

  const getServiceDetails = async () => {
    try {
      const response = await getServiceDetailsApi(id);

      if (response.data.success === true) {
        setServiceDetail(response.data.service ?? {});
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const columns = [
    {
      header: "Item",
      accessorKey: "item",
      cell: ({ getValue, row }) => {
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
          </div>
        );
      },
    },

    {
      header: "Labour",
      accessorKey: "labour",
      cell: ({ getValue, row }) => {
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              {getValue()}
            </div>
          </div>
        );
      },
    },
    {
      header: "Part",
      accessorKey: "part",
      cell: ({ getValue, row }) => {
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              {getValue()}
            </div>
          </div>
        );
      },
    },
    {
      header: "Labour Cost",
      accessorKey: "labour_cost",
      cell: ({ getValue, row }) => {
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
          </div>
        );
      },
    },

    {
      header: "Part Cost",
      accessorKey: "part_cost",
      cell: ({ getValue, row }) => {
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
          </div>
        );
      },
    },
    {
      header: "Total Cost",
      accessorKey: "total_cost",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "150px",
              maxWidth: "200px",
            }}
          >
            {info.getValue()}
          </div>
        );
      },
    },
  ];
  const data = useMemo(() => MOCK_DATA, []);
  const [globalFilter, setGlobalFilter] = useState("");

  const table = useReactTable({
    data: serviceDetail.items ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const pageOptions = table.getPageOptions();
  const { pageIndex, pageSize } = table.getState().pagination;
  const details = [
    {
      label: "Odometer",
      value: serviceDetail.odometer ?? "---",
    },
    {
      label: "Start date",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="vendor" />
          <span>{serviceDetail.start_date ?? "---"}</span>
        </div>
      ),
    },
    {
      label: "Completion date",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="vendor" />
          <span>{serviceDetail.completion_date ?? "---"}</span>
        </div>
      ),
    },
    {
      label: "Vendor",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={vendor} alt="vendor" />
          <span>{serviceDetail.vendor ?? "---"}</span>
        </div>
      ),
    },
    {
      label: "Issue",
      value: serviceDetail.issue ?? "---",
    },
  ];

  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  function onSuccessStatusUpdate() {
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getServiceDetails();
  }
function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  return (
    <>
      {showStatusUpdate && (
        <StatusUpdateModal
          serviceDetail={serviceDetail}
          success={onSuccessStatusUpdate}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <div className="bg-half-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MoveLeft />
            </div>
            <div className="rounded-4 p-4" style={{ backgroundColor: "#F5F2FF" }}>
              <img src={service} alt="issue" />
            </div>
            <div>
              <p className="m-0 fs-20 fw-semibold mb-1">{serviceDetail.service_id ?? ""}</p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-14" style={{color:'#A2A7AE'}}>{serviceDetail.issue ?? ""} </span>
                <span className="me-2">•</span>
                <span className="border-0 fs-12 py-1 px-4 rounded-pill fw-600" style={{ backgroundColor: "#E5FFF0", color:'#2C8C53' }}>
                  {serviceDetail.status ?? ""}
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center mt-3 mt-xl-0 gap-3">
            {serviceDetail.status !== "Closed" && (
              <Button
                onClick={() => {
                  setShowStatusUpdate(true);
                }}
                className="rounded-pill py-2 px-4 fs-14 fw-500"
              >
                Update status
              </Button>
            )}

            {checkPermission("Service", "delete_permission") && serviceDetail.status !== "Closed" && (
              <Button
                onClick={() => {
                  navigate("/service/create", { state: { id: id } });
                }}
                className="dark-purple-btn rounded-pill py-2 px-4 fs-16 fw-600"
              >
                Edit
              </Button>
            )}
            {/*  <div className="border rounded-circle p-2 cursor-pointer">
              <EllipsisVertical />
            </div> */}
          </div>
        </div>
        <div className="row w-100 m-0 pt-3">
          <div className="col-xl-7 h-100">
            <div className="bg-white h-100 p-3 rounded-4">
              <div className="p-3 rounded-4" style={{ backgroundColor: "#F8F8F8" }}>
                <div className="d-flex gap-3">
                  <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
                    <img src={tata} alt="tata" />
                  </div>
                  <div>
                    <p className="m-0 fs-16 fw-600 mb-1">{serviceDetail.lic_no ?? "-"} </p>
                    <div className="d-flex align-items-center">
                      <span className="me-2 fs-14 fw-400" style={{color:'#A2A7AE'}}>{serviceDetail.name ?? "-"}</span>
                      <span className="me-2">•</span>
                      {serviceDetail.year_of_make &&(<span style={{background:'#F0DBFF', color:'#A2A7AE'}} className="border-0 py-1 px-4 rounded-pill  fs-12">{serviceDetail.year_of_make ?? ""}</span>)}
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-center align-items-center">
                  <span className="fs-13 fw-400"  style={{ color: "#8790A1" }}>Vehicle identification number (VIN) : </span>
                  <span className="fs-14 fw-500" style={{ color: "#172B4D" }}>&nbsp; {serviceDetail.vin ?? ""}</span>
                </div>
              </div>
              <p className="fs-16 fw-600 m-0 mt-3" style={{ color: "#212129" }}>Work order information</p>
              <div className="table-container rounded-4 overflow-hidden my-2">
                <table className="table table-borderless mb-0">
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td className="fs-13 fw-500 w-28" style={{ color: "#49494B" }}>
                          {item.label}
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
        </div>
          <div className="col-xl-5">
            <div className="bg-white p-3 rounded-4">
              <p className="fs-16 fw-600 m-0 mt-3" style={{ color: "#212129" }}>Attachments - {serviceDetail?.images?.length}</p>
              {serviceDetail?.images?.length > 0 && (
                <div className="row gap-2">
                  {serviceDetail?.images?.map((item, attachIndex) => (
                    <div style={{ width: "312px" }}>
                      <div className="d-flex align-items-center bg-white rounded-4 p-2" style={{ border: "1px solid #EBEBEB" }}>
                        <img src={attachment} alt="attachment" style={{ width: "24px", height: "24px" }} />
                        <div style={{ width: "calc(100% - 32px)", marginLeft: "8px" }}>
                          <div className="fs-13 fw-500" style={{ width: "100%", color: "#172B4D", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item.file_name ?? "Attachment"}
                          </div>
                          <div className="fs-12 fw-400" style={{ color: "#8790A1" }}>
                            {item.file_size ?? "80.62 KB"}
                          </div>
                        </div>
                        {item.url && (
                          <div
                            onClick={() => {
                              downloadFile(item.url, item.url.split("/").pop());
                            }}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                            }}
                          >
                            <img
                              src={download}
                              alt="download"
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* <div className="d-flex align-items-center gap-4 justify-content-between">
                <div
                  className="rounded-4 px-3 py-2 w-50"
                  style={{ border: "1px solid #EBEBEB" }}
                >
                  <div className="d-flex gap-3">
                    <img src={pdf} alt="pdf" />
                    <div className="d-flex flex-column">
                      <p className="m-0" style={{ color: "#172B4D" }}>
                        Contact Listing.pdf
                      </p>
                      <p className="m-0" style={{ color: "#8790A1" }}>
                        80.62 MB
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="rounded-4 px-3 py-2 w-50"
                  style={{ border: "1px solid #EBEBEB" }}
                >
                  <div className="d-flex gap-3">
                    <img src={pdf} alt="pdf" />
                    <div className="d-flex flex-column">
                      <p className="m-0" style={{ color: "#172B4D" }}>
                        Contact Listing.pdf
                      </p>
                      <p className="m-0" style={{ color: "#8790A1" }}>
                        80.62 MB
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="bg-white rounded-4 p-3 mt-3 overflow-y-auto hide-scroll" style={{ height: "365px" }}>
              <div>
                <h6 className="fs-16 fw-600 m-0 mb-3" style={{ color: "#212129" }}>Workorder - {serviceDetail.workorders?.length}</h6>
                {serviceDetail.workorders?.map((workorder, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start justify-content-between py-3 border-bottom"
                    style={{ fontSize: "14px" }}
                    onClick={
                      workorder.id != null
                        ? () => {
                            navigate("/workorder/view", { state: { id: workorder.id } });
                          }
                        : () => {}
                    }
                  >
                    <div className="d-flex">
                      <div className="rounded-circle bg-light d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px" }}>
                        <img src={user} alt="" />
                      </div>
                      <div>
                        <div className="fw-500 fs-13">{workorder.title}</div>
                        <div className="text-muted fw-400 fs-12">{workorder.work_order_id}</div>
                      </div>
                    </div>
                    <p className="text-muted fw-500 fs-11">{workorder.date}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="bg-white rounded-4 p-3 mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="fs-16 fw-600" style={{ color: "#212129" }}>Line Items</p>
              </div>
              <div className="row gap-3 m-0">
                <div className="col-xl-2 d-flex py-2 rounded-4 gap-3" style={{ backgroundColor: "#F2E0FF" }}>
                  <img src={labor} alt="labor" />
                  <div className="d-flex flex-column">
                    <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                      Labor
                    </p>
                    <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                      {serviceDetail.labour_cost ?? "---"}
                    </p>
                  </div>
                </div>
                <div className="col-xl-2 d-flex py-3 rounded-4 gap-3" style={{ backgroundColor: "#D5FFEE" }}>
                  <img src={parts} alt="labor" />
                  <div className="d-flex flex-column">
                    <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                      Parts
                    </p>
                    <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                      {serviceDetail.part_cost ?? "---"}
                    </p>
                  </div>
                </div>
                <div className="col-xl-2 d-flex py-3 rounded-4 gap-3" style={{ backgroundColor: "#EFF0FF" }}>
                  <img src={total} alt="labor" />
                  <div className="d-flex flex-column">
                    <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                      Total
                    </p>
                    <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                      {serviceDetail.total_cost ?? "---"}
                    </p>
                  </div>
                </div>
              </div>
              {/* Table */}
              <div className="mt-3">
                <div className="table-wrapper overflow-x-auto">
                  <table>
                    <thead>
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                          {headerGroup.headers.map((header) => (
                            <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                              {flexRender(header.column.columnDef.header, header.getContext())}
                              {header.column.getIsSorted() === "asc" && " asc"}
                              {header.column.getIsSorted() === "desc" && " des"}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody>
                      {table.getRowModel().rows.map((row) => (
                        <tr key={row.id}>
                          {row.getVisibleCells().map((cell) => (
                            <td key={cell.id} className="px-3 py-2">
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <Dropdown>
                    <span className="pagination-color">Records per page: &nbsp;</span>
                    <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                      <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                        {pageSize} <img src={down} alt="" />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                      {[10, 25, 50, 75, 100].map((size) => (
                        <Dropdown.Item key={size} onClick={() => table.setPageSize(size)} active={pageSize === size} className="text-center">
                          {size}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  <div className="d-flex align-items-center gap-2">
                    <button className="pagination-border bg-white rounded-circle p-2" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                      <ChevronLeft className="pagination-color" />
                    </button>

                    {pageOptions.length > 0 &&
                      (() => {
                        const totalPages = pageOptions.length;
                        const maxVisible = 3;
                        let start = Math.max(0, pageIndex - Math.floor(maxVisible / 2));
                        let end = start + maxVisible;
                        if (end > totalPages) {
                          end = totalPages;
                          start = Math.max(0, totalPages - maxVisible);
                        }
                        const visiblePages = pageOptions.slice(start, end);
                        return (
                          <>
                            {visiblePages.map((pageNum) => (
                              <button key={pageNum} className={`pagination-border rounded-circle p-2 px-3 ${pageIndex === pageNum ? "dark-purple-btn" : "bg-white pagination-color"}`} onClick={() => table.setPageIndex(pageNum)}>
                                {pageNum + 1}
                              </button>
                            ))}
                            {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
                              <>
                                <span className="mx-2 pagination-color">...</span>
                                <button className={`pagination-border rounded-circle p-2 px-3 ${pageIndex === totalPages - 1 ? "dark-purple-btn" : "bg-white pagination-color"}`} onClick={() => table.setPageIndex(totalPages - 1)}>
                                  {totalPages}
                                </button>
                              </>
                            )}
                          </>
                        );
                      })()}

                    <button className="pagination-border bg-white rounded-circle p-2" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                      <ChevronRight className="pagination-color" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
